<template>
	<el-dialog title="编辑消息" :visible.sync="visible" width="500px" @close="onClose">
		<!-- 文本类型 -->
		<div v-if="editType === 0">
			<el-input
				v-model="content"
				type="textarea"
				:rows="4"
				placeholder="请输入消息内容"
			></el-input>
		</div>

		<!-- 图片类型 -->
		<div v-else-if="editType === 1">
			<div v-if="imageData || tempImagePreview" class="image-preview">
				<img :src="imageData ? imageData.thumbUrl : tempImagePreview.thumbUrl" alt="预览图片" />
				<span v-if="imageData" class="remove-image" @click="removeImage">
					<i class="el-icon-close"></i>
				</span>
				<span v-else class="uploading-indicator">
					<i class="el-icon-loading"></i>
					<span>上传中...</span>
				</span>
			</div>
			<file-upload
				:action="'/image/upload'"
				:maxSize="10 * 1024 * 1024"
				:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
				@before="onImageBefore"
				@success="onImageSuccess"
				@fail="onImageFail"
			>
				<el-button type="primary" icon="el-icon-upload">上传图片</el-button>
			</file-upload>
			<p v-if="!imageData && !tempImagePreview" class="tip">点击按钮上传新图片</p>
		</div>

		<div slot="footer" class="dialog-footer">
			<el-button @click="onClose">取消</el-button>
			<el-button type="primary" @click="onConfirm" :disabled="!canSubmit">确认</el-button>
		</div>
	</el-dialog>
</template>

<script>
import FileUpload from './FileUpload.vue';

export default {
	name: 'EditMessageModal',
	components: {
		FileUpload
	},
	props: {
		msgInfo: {
			type: Object
		}
	},
	data() {
			return {
				visible: false,
				content: '',
				editType: 0,
				imageData: null,
				tempImagePreview: null  // 上传过程中的临时预览
			}
		},
	computed: {
		canSubmit() {
			if (this.editType === 0) {
				return this.content.trim() !== '';
			} else if (this.editType === 1) {
				return this.imageData !== null;
			}
			return false;
		}
	},
	methods: {
		open() {
			// 根据消息类型判断编辑类型
			// 假设 msgInfo.type 为 0 是文本，为 1 是图片
			this.editType = this.msgInfo.type === this.$enums.MESSAGE_TYPE.TEXT ? 0 : 1;

			if (this.editType === 0) {
				// 文本类型，直接赋值 content
				this.content = this.msgInfo.content;
			} else if (this.editType === 1) {
				// 图片类型，解析 content 为 JSON
				try {
					let parsed = JSON.parse(this.msgInfo.content);
					// 只有当图片已上传成功（有服务端返回的URL）才设置为已完成状态
					if (parsed.originUrl && parsed.originUrl.startsWith('http')) {
						this.imageData = parsed;
					} else {
						this.imageData = null;
					}
				} catch (e) {
					this.imageData = null;
				}
			}

			this.visible = true;
		},

		onClose() {
			this.visible = false;
			this.content = '';
			this.imageData = null;
		},

		onConfirm() {
			let data = {
        messageId: this.msgInfo.id,
				content: this.editType === 0 ? this.content : JSON.stringify(this.imageData)
			};

			this.$http({
				url: "/message/group/editMessage",
				method: "post",
				data: data
			}).then(() => {
				this.$message.success("编辑成功");
				this.$emit("success", data);
				this.onClose();
			}).catch(() => {
				this.$message.error("编辑失败");
			});
		},

		onImageBefore(file) {
			// 上传前不设置 imageData，只显示临时预览
			let url = URL.createObjectURL(file);
			this.tempImagePreview = {
				originUrl: url,
				thumbUrl: url
			};

			// 获取图片尺寸
			this.getImageSize(file).then(size => {
				this.tempImagePreview.width = size.width;
				this.tempImagePreview.height = size.height;
			});
		},

		onImageSuccess(data, file) {
			// 上传成功后才设置 imageData，此时才能点击确认
			this.imageData = {
				originUrl: data.originUrl,
				thumbUrl: data.thumbUrl,
				width: data.width,
				height: data.height
			};
			// 清理临时预览
			this.tempImagePreview = null;
		},

		onImageFail(e, file) {
			this.$message.error("图片上传失败");
			this.imageData = null;
			this.tempImagePreview = null;
		},

		removeImage() {
			this.imageData = null;
			this.tempImagePreview = null;
		},

		getImageSize(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = function (event) {
					const img = new Image();
					img.onload = function () {
						resolve({width: img.width, height: img.height});
					};
					img.onerror = function () {
						reject(new Error('无法加载图片'));
					};
					img.src = event.target.result;
				};
				reader.onerror = function () {
					reject(new Error('无法读取文件'));
				};
				reader.readAsDataURL(file);
			});
		}
	}
}
</script>

<style scoped>
.image-preview {
	position: relative;
	margin-bottom: 16px;
	max-width: 100%;
}

.image-preview img {
	max-width: 100%;
	height: auto;
	border-radius: 4px;
}

.remove-image {
	position: absolute;
	top: -10px;
	right: -10px;
	width: 24px;
	height: 24px;
	background: #fff;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.tip {
	margin-top: 8px;
	color: #999;
	font-size: 12px;
}

.uploading-indicator {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgba(0, 0, 0, 0.6);
	color: #fff;
	padding: 8px 16px;
	border-radius: 4px;
	display: flex;
	align-items: center;
	gap: 8px;
}

.uploading-indicator i {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>
